import { render } from "./ProductionReport.vue?vue&type=template&id=b6dc270e&scoped=true"
import script from "./ProductionReport.vue?vue&type=script&lang=js"
export * from "./ProductionReport.vue?vue&type=script&lang=js"

import "./ProductionReport.vue?vue&type=style&index=0&id=b6dc270e&scoped=true&lang=css"

import exportComponent from "/var/www/html/minty.crm.frontend.merchant/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b6dc270e"]])

export default __exports__